/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SecurityLockClosedIcon20Solid = forwardRef('SecurityLockClosedIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 1a5 5 0 0 0-5 5v1.17A3.001 3.001 0 0 0 3 10v5a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-5a3.001 3.001 0 0 0-2-2.83V6a5 5 0 0 0-5-5Zm3 6V6a3 3 0 1 0-6 0v1h6Zm-2.25 6.05a1.5 1.5 0 1 0-1.5 0v1.45a.75.75 0 0 0 1.5 0v-1.45Z" })));
});
